import { render, staticRenderFns } from "./CVJobValidation.vue?vue&type=template&id=2227f641&scoped=true"
import script from "./CVJobValidation.vue?vue&type=script&lang=js"
export * from "./CVJobValidation.vue?vue&type=script&lang=js"
import style0 from "./CVJobValidation.vue?vue&type=style&index=0&id=2227f641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227f641",
  null
  
)

export default component.exports